import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SiteLayout from "./components/layout/SiteLayout";
import Home from "./pages/Home";
import EpoxyFlooring from "./pages/EpoxyFlooring";
import Waterproofing from "./pages/Waterproofing";
import Painting from "./pages/Painting";
import Projects from "./pages/Projects";
import About from "./pages/About";
import FAQPage from "./pages/FAQ";
import Contact from "./pages/Contact";
import AdminLeads from "./pages/AdminLeads";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SiteLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/epoxy-flooring" element={<EpoxyFlooring />} />
            <Route path="/waterproofing" element={<Waterproofing />} />
            <Route path="/painting" element={<Painting />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </SiteLayout>
      </BrowserRouter>
    </div>
  );
}

export default App;
